import React, { useEffect, useState } from 'react';
import { PeriodosAdapter, AñoPeriodoEntity } from '../../../../../infraestructure/persistence/rest/PeriodosAdapter';
import { useNotifications } from '../../../../../shared/hooks/Notifications';
import { ServerErrorMessage } from '../../../../../shared/utils/error';
import SelectorInformes from './selector';

export const SelectorInformesContainer = (props: any) => {
	let { año, periodo, informesExcel, MostrarTODOS } = props;

	const api = new PeriodosAdapter();
	const { exceptionError, resultError } = useNotifications();
	let [informes, setInformes] = useState<any>([])
	let result: any;
  
  useEffect(()=>{
	getInformes(año, periodo);
  },[año, periodo])

	const getInformes = async (año: number, periodo: number) => {
		try {			
			if((año != undefined && periodo != undefined) || (informesExcel != undefined && informesExcel)){
				if(informesExcel)
				result = await api.ListarInformesExcel();
				else
					result = await api.ListarInformesAñoPeriodo({año: año, periodo: periodo});
				if(result.data && result.data!=="")
				{
					setInformes([ ...result.data ] || []);
				}else{resultError()}
			}else{
				setInformes([]);
			}
		} catch (error) {
			let exception = ServerErrorMessage(error);
			exceptionError(exception)
		}
  };

  return <SelectorInformes {...props} data={informes}/>
};

export default SelectorInformesContainer;